import { Pipe, PipeTransform } from '@angular/core';

/**
 * Transforms locale codes between two standarts.
 *
 * Our FE application works with codes similar to 'cs', 'en', etc.,
 * but Back-end uses 'CZ', 'EN', ..., that's why we need to transform the codes.
 *
 * USAGE IN CODE:
 * This pipe ships with shared module. You need to inject her in constructor similar to this:
 * constructor(private languageCodePipe: LanguageCodePipe)
 *
 * Then you can do:
 * this.languageCodePipe.transform(this.lang, 'toUpper')
 *
 * USAGE IN TEMPLATE:
 * {{ lang | ssfLanguageCode:'toUpper' }} --- equals CZ if lang is 'cs'
 */
@Pipe({name: 'ssfLanguageCode'})
export class LanguageCodePipe implements PipeTransform {
    transform(lang: string, type: string): string {
        switch (type) {
            case 'toLower': { // to BCP47
                switch (lang) {
                    case 'CZ': {
                        return 'cs';
                    }
                    case 'EN': {
                        return 'en';
                    }
                    default: {
                        throw new SyntaxError();
                    }
                }
            }
            case 'toUpper': { // to ISO 3166
                switch (lang) {
                    case 'cs': {
                        return 'CZ';
                    }
                    case 'en': {
                        return 'EN';
                    }
                    default: {
                        throw new SyntaxError();
                    }
                }
            }
            default: {
                throw new SyntaxError();
            }
        }
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src!./~/tslint-loader!./src/app/modules/shared/pipes/language-code.pipe.ts